"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Heart.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Heart = function Heart(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 231.93 203.9"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "line-icon-heart"), _react2.default.createElement("path", {
    className: "heart",
    d: "M231.51 60.8c-3.4-35.2-29.7-60.8-62.7-60.8a63 63 0 0 0-53.4 29.1A61 61 0 0 0 63.21 0C30.11 0 3.81 25.6.41 60.8c-.3 1.6-1.4 9.7 2 23.1 4.8 19.3 15.9 36.8 32.1 50.7l80.8 69.3 82.2-69.3c16.2-13.9 27.3-31.4 32.1-50.7 3.3-13.3 2.2-21.5 1.9-23.1zM220.91 82c-4.4 17.6-14.6 33.6-29.4 46.3l-76.2 64.3-74.9-64.3c-14.8-12.7-25-28.7-29.4-46.3-3.1-12.7-1.8-19.8-1.8-19.8l.1-.4c2.8-30.9 25.5-53.4 53.9-53.4 20.9 0 39.3 12.2 48 31.7l4.1 9.2 4.1-9.2a53.92 53.92 0 0 1 49.4-31.7c28.3 0 51 22.4 54 53.7-.1.1 1.2 7.2-1.9 19.9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Heart;